module.exports = __webpack_public_path__ + "static/img/2_2.8456e9ff.jpg";